<template>
    <Breadcrumbs main="Bonus Ui" title="Draggable Card" />
    <div class="container-fluid">

        <draggable class="row">
            <draggableCard />
            <shadowCard />
            <iconCard />
            <checboxCard />
        </draggable>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
import { VueDraggableNext } from 'vue-draggable-next'
const draggable = VueDraggableNext
const draggableCard = defineAsyncComponent(() => import("@/components/theme/advance/draggable/draggableCard.vue"))
const shadowCard = defineAsyncComponent(() => import("@/components/theme/advance/draggable/shadowCard.vue"))
const iconCard = defineAsyncComponent(() => import("@/components/theme/advance/draggable/iconCard.vue"))
const checboxCard = defineAsyncComponent(() => import("@/components/theme/advance/draggable/checboxCard.vue"))
</script>